import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["badge"];

  connect() {
    this.refreshBound = this.refresh.bind(this);
    window.addEventListener("supercast-queue-changed", this.refreshBound);

    this.refresh();
  }

  disconnect() {
    window.removeEventListener("supercast-queue-changed", this.refreshBound);
  }

  async refresh() {
    const queue = await window.queueDb.getQueue();
    const count = queue.length;

    this.badgeTarget.textContent = count;
    this.badgeTarget.classList.toggle("hidden", count === 0);
    this.badgeTarget.classList.toggle("flex", count > 0);
  }
}
